import * as React from 'react';
import { GridToolbarContainer, GridToolbarExport, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector } from '@mui/x-data-grid';

export function CustomToolbarWithoutExport() {
  return (
    <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} csvOptions={{
          disableToolbarButton: true
        }}/>
    </GridToolbarContainer>
  );
}